$(function() {
  const gHeader = $('#js-global-header').height()

  function pagelink(heightnum) {
    const headerH = heightnum
    $('a[href^="#"]').click(function() {
      const href = $(this).attr('href')
      const target = $(href == '#' || href == '' ? 'body' : href)
      const position = target.offset().top - headerH

      $('html, body').animate({ scrollTop: position }, 800, 'swing')
      return false
    })
  }
  pagelink(gHeader)
})
